import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { useItManagementFeatureAvailability } from 'modules/it_management/hooks/useItManagementFeatureAvailability'
import CollectionsBootstrap from 'modules/it_management/lib/CollectionsBootstrap'

const Container = () => {
  const {
    employee,
    access: { id: accessId },
  } = useCurrentSession()
  return (
    <Outlet
      context={{
        currentUserId: accessId,
        employee,
      }}
    />
  )
}

const RootPage = () => {
  const {
    isItManagementEnabled,
    loading: featureLoading,
    error: featureError,
  } = useItManagementFeatureAvailability()

  if (featureLoading) {
    return null
  }

  return (
    <AuthorizeUser authorizeFn={() => !featureError && isItManagementEnabled}>
      <CollectionsBootstrap>
        <Container />
      </CollectionsBootstrap>
    </AuthorizeUser>
  )
}

export default RootPage
